import * as Actions from './type';

import { getUserDetailsApi } from '../../api/dashboard-owner/dashboard-owner-api';

export const getUserDetails = () => async (dispatch) => {
  try {
    dispatch({
      type: Actions.USER_DETAILS_REQUEST,
    });

    const { data } = await getUserDetailsApi();

    dispatch({
      type: Actions.USER_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.USER_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
